import { useState, useEffect, useRef, useMemo } from 'react';
import {
    Box, Card, TextField, Autocomplete, Tooltip, FormControl, RadioGroup,
    FormControlLabel, Radio, Table, TableHead, TableRow, TableCell, TableBody,
    Button
} from '@mui/material';
import { Colors } from '../../../../Styles/Colors';
import { renderTitle, renderIconButton } from "./SarasCommonComp";
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { qDoctorPatientId, qDoctorAppointmentId } from '../../../../Utility/Services/DoctorPatientQueryIds';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { withTranslation } from 'react-i18next';
import ShowComponents from '../Common/ShowComponent';
import { DeletePopup, CommonDeleteButton } from '../../../../Components/Common Components/CommonComponents';
import { debounce } from '../../../../Components/CommonFunctions/CommonFunctions';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import SarasBoldItalic from './SarasBoldItalic';
import PreviousDiagnosis from '../Common/PreviousDiagnosis';
import HistoryIcon from '@mui/icons-material/History';

const headers = ['ICD Code', 'Short Description', 'Long Description', 'Action'];

const SarasIcdDiagnosis = ({ Title, ...props }) => {
    const [state, setState] = useState({
        DiagnosisData: [],
        isDeleteClicked: false,
        SelectedList: {},
        SearchBy: "icd_code",
        FrequentData: [],
        IcdSearchKey: "",
        ICDdatas: [],
        selecticd: null,
        selectShortDesc: null,
        selectlongDesc: null,
        postLoading: false,
        PreviousDiagnosisPopup: false,
        dateList: [],
        IcdCodeData: [],
        is_previous_loading: false,
    });

    const debouncedGetSuggest = useRef(null);

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    useEffect(() => {
        debouncedGetSuggest.current = debounce((value, searchBy) => {
            getSuggestionList(value, searchBy);
        }, 500);
    }, []);

    const getApiCall = () => {
        getIcdCodeData();
        getICDFrequents();
        if (!props?.fromIp) {
            getPreviousDiagnosis();
        }
    }

    const getIcdCodeData = () => {
        const { appointmentId, admission_id, clinicId, doctor_id } = props
        try {
            let params = props?.fromIp ? Serviceurls.SAR_IP_DOC_NOTES_DIAGNOSIS + `?ip_admission_id=${admission_id}&clinic_id=${clinicId}&doctor_id=${doctor_id}` : Serviceurls.SARAS_DOC_ICD_DIAGNOSIS_GET + `?appointment_id=${qDoctorAppointmentId(appointmentId)}`
            RestAPIService.getAllTwo(params)
                .then((response) => {
                    if (response.data.status === "success") {
                        updateState({ DiagnosisData: response.data.data || [] })
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (e) {
            props.errorMessage(e.message)
        }
    }

    const getPreviousDiagnosis = (date = "") => {
        try {
            const { appointmentId, patientId } = props
            const url = `${Serviceurls.SARAS_DOC_PREVIOUS_ICD_GET}?patient_id=${qDoctorPatientId(patientId)}&appointment_id=${qDoctorAppointmentId(appointmentId)}`
            updateState({ IcdCodeData: [], is_previous_loading: true });
            RestAPIService.getAll(url + (date ? `&date=${date}` : ""))
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const responseData = response?.data?.data || [];
                        const dates = response?.data?.dates || state.dateList;

                        updateState({
                            dateList: dates,
                            IcdCodeData: responseData?.map( item => ({
                                appointment_id: item.appointment_id,
                                icd_code: item.icd_codes || [],
                            })),
                            is_previous_loading: false
                        })
                    }
                }).catch((error) => {
                    updateState({is_previous_loading: false})
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            updateState({is_previous_loading: false})
            props.errorMessage(error.message)
        }
    }

    const getICDFrequents = () => {
        try {
            let params = ''
            if(props?.fromIp){
                params = Serviceurls.SAR_IP_DOC_NOTES_DIAGNOSIS_SUGG_GET + `?clinic_id=${props?.clinicId}&ip_admission_id=${props?.admission_id}&doctor_id=${props?.doctor_id}`
            }else{
                params = Serviceurls.SARAS_DOC_ICD_DIAG_FREQ_GET
            }
            RestAPIService.getAll(params)
                .then((response) => {
                    if (response.data.status === "success") {
                        updateState({
                            FrequentData: response.data.data
                        })
                    }
                    else {
                        props.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    props.errorMessage(error.message)
                })
        }
        catch (e) {
            props.errorMessage(e.message)
        }
    }

    const getSuggestionList = (searchKey = '', searchBy = 'icd_code') => {
        try {
            RestAPIService.getAllTwo(Serviceurls.DOC_REGISTRY_ICD_SEARCH + `?${searchBy}=${searchKey}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        updateState({
                            ICDdatas: response.data ? response.data.data : []
                        })
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        }
        catch (e) {
            props.errorMessage(e.message)
        }
    }

    // delete functions
    const popupClose = () => {
        updateState({
            isDeleteClicked: false,
            SelectedList: {},
        })
    }

    const deleteIcdDiagnosis = () => {
        try {
            let urls = props?.fromIp ? Serviceurls.SAR_IP_DOC_NOTES_DIAGNOSIS : Serviceurls.SARAS_DOC_ICD_DIAGNOSIS_GET
            RestAPIService.delete(urls + "?id=" + state.SelectedList.id)
                .then((response) => {
                    if (response.data.status === "success") {
                        popupClose()
                        props.successMessage(response.data.message)
                        getIcdCodeData()
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch(error => {
                    props.errorMessage(error.message)
                })
        } catch (e) {
            props.errorMessage(e.message)
        }
    }

    const closePreviousPopup = () => {updateState({PreviousDiagnosisPopup: false})}

    const postIcdCode = (copyData = {}) => {
        const { appointmentId, patientId } = props
        try {
            const data = {
                "appointment_id": appointmentId,
                "patient_id": patientId,
                "icd_code": state?.selecticd ? (props?.fromIp ? state.selecticd?.icd_code : [state.selecticd?.icd_code]) : null,
            };

            if (props?.fromIp) {
                data['clinic_id'] = props?.clinicId || null
                data['ip_admission_id'] = props?.admission_id || null
                data['doctor_id'] = props?.doctor_id || null
            }

            updateState({ postLoading: true })
            const isCopyData = copyData && Object.keys(copyData)?.length > 0;
            if ((state?.selecticd && Object.keys(state?.selecticd).length > 0) || isCopyData) {
                let urlsD = props?.fromIp ? Serviceurls.SAR_IP_DOC_NOTES_DIAGNOSIS : Serviceurls.SARAS_DOC_ICD_DIAGNOSIS_GET
                RestAPIService.create(isCopyData ? copyData : data, urlsD)
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            props.successMessage(response?.data?.message)
                            onClearHandler()
                            getIcdCodeData()
                            getICDFrequents()
                            if(props?.fromIp){
                                props?.callHistory(true)
                            }
                            if(isCopyData){
                                closePreviousPopup()
                            }
                        }
                    }).catch((error) => {
                        updateState({ postLoading: false })
                        props.errorMessage(error?.response?.data?.message || error.message)
                    })
            } else {
                props.errorMessage(`Enter ${Title}`)
            }
        } catch (error) {
            updateState({ postLoading: false })
            props.errorMessage(error.message)
        }
    }

    const handleDiagnosisCopy = (passedData) => {
        const { appointmentId, patientId } = props
        const data = {
            appointment_id: appointmentId,
            patient_id: patientId,
            icd_code: passedData?.icd_code?.length > 0 ? passedData?.icd_code?.map((item) => item.icd_code) : []
        }
        postIcdCode(data)
    }

    const onClearHandler = () => {
        updateState({
            IcdSearchKey: "",
            ICDdatas: [],
            selecticd: null,
            selectShortDesc: null,
            selectlongDesc: null,
            SearchBy: "icd_code",
            postLoading: false,
        })
    }

    const renderIcdCode = () => {
        return (<Autocomplete
            sx={{ width: "100%" }}
            onClose={() => {
                if (!state.selecticd && state.ICDdatas?.length > 0) {
                    updateState({ ICDdatas: [] })
                }
            }}
            noOptionsText={state.IcdSearchKey === '' ? 'Please Search...' : 'No Data Found...'}
            options={state.IcdSearchKey === "" ? state.FrequentData : state.ICDdatas}
            getOptionLabel={(options) => options.icd_code + " | " + (options.short_desc || options.icd_short_desc) + " | " + (options.desc || options.icd_desc)}
            onChange={(e, value) => { updateState({ selecticd: value }) }}
            value={state.selecticd}
            size='small'
            disablePortal
            renderInput={(params) => <TextField onChange={(event) => {
                const value = event.target.value
                if (value) {
                    updateState({ IcdSearchKey: value })
                    debouncedGetSuggest.current(value, state.SearchBy);
                } else {
                    updateState({ IcdSearchKey: value, ICDdatas: [] })
                }
            }} {...params} placeholder={state.SearchBy === "icd_code" ? "Enter ICD Code" : "Enter Description"} />}
        />)
    }

    const renderIcdCodeAutocomplete = (stateKey) => (
        <Autocomplete
            sx={{ width: "100%" }}
            noOptionsText="No Data Found..."
            disabled={state.IcdSearchKey}
            options={state.FrequentData}
            getOptionLabel={(opt) => `${stateKey === "selectlongDesc" ? (opt.desc || opt.icd_desc) : (opt.short_desc || opt.icd_short_desc)}`}
            onChange={(e, val) => updateState({ selecticd: val })}
            value={state.selecticd || null}
            size="small"
            disablePortal
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={
                        state.SearchBy === "icd_code" ? "Enter ICD Code" : "Enter Description"
                    }
                />
            )}
        />
    );

    const { t, isLocked } = props;

    const disableBtn = useMemo(() => {
        return !(state.selecticd) || state.postLoading || isLocked;
    }, [state.selecticd, state.postLoading, isLocked]);

    return (
        <ShowComponents onIntersection={getApiCall.bind(this)}>
            <Card sx={{
                width: "100%", height: "fit-content", padding: "0.3vw",
                marginBottom: "0.5vw", border: `2px solid ${props.isSelected ? Colors.themeDark : Colors.white}`
            }}>
                <Box display={"flex"} flexDirection={'row'} alignItems={"center"} justifyContent={'space-between'} padding={"0.5vw"} borderBottom={`1px solid #E3E2E2`}>
                    {renderTitle(Title, props.isSelected, !props?.fromIp ? <Button
                        className='Common_Btn_Min_Width'
                        disabled={state.postLoading || isLocked}
                        onClick={() => { updateState({ PreviousDiagnosisPopup: true }) }}
                    >
                        <Tooltip placement='top' title={`Previous ${Title}`}>
                            <HistoryIcon color={(state.postLoading || isLocked) ? "disabled" : "primary"} sx={{ height: '1.7vw', width: '1.7vw' }} />
                        </Tooltip>
                    </Button> : null)}
                    <FormControl sx={{ marginLeft: "1vw" }}>
                        <RadioGroup row
                            value={state.SearchBy}
                            onChange={(e) => {
                                updateState({ SearchBy: e.target.value })
                            }}
                        >
                            <FormControlLabel value="icd_code" control={<Radio size='small' />} label="Search by ICD Code" />
                            <FormControlLabel value="desc" control={<Radio size='small' />} label="Search by Description" />
                        </RadioGroup>
                    </FormControl>
                </Box>
                <Card sx={{ width: "100%", height: "fit-content", marginBottom: "0.625vw" }}>
                    <Table size='small' stickyHeader aria-label="sticky table" sx={{ maxHeight: '20vw', overflowY: 'auto' }}>
                        <TableHead>
                            <TableRow sx={{ '& td': { px: '0.2vw' } }}>
                                {headers.map((text, idx) => (
                                    <TableCell
                                        key={idx}
                                        align={headers.length - 1 === idx ? "center" : "left"}
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: '0.9vw',
                                            color: Colors.SecondaryText,
                                            backgroundColor: Colors.Background,
                                            px: '0.2vw'
                                        }}
                                    >
                                        {text}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow sx={{ height: '3vw', '& td': { px: '0.2vw', verticalAlign: 'middle', } }}>
                                <TableCell align="left" sx={{ width: "12vw" }}>
                                    {renderIcdCode()}
                                </TableCell>
                                <TableCell align="left" sx={{ width: "14vw" }}>
                                    {renderIcdCodeAutocomplete("selectShortDesc")}
                                </TableCell>
                                <TableCell align="left" sx={{ width: "16vw" }}>
                                    {renderIcdCodeAutocomplete("selectlongDesc")}
                                </TableCell>
                                <TableCell align="center" sx={{ width: "2vw" }}>
                                    {renderIconButton('Add', ImagePaths[disableBtn ? 'DisabledAddIcon' : 'AddIcon'].default, () => postIcdCode(), disableBtn, "2vw")}
                                </TableCell>
                            </TableRow>
                            {
                                state.DiagnosisData?.length > 0 ? state.DiagnosisData?.map((item, index) => (
                                    <TableRow key={index} sx={{ '& td': { pl: '0.3vw', pr: "0.2vw", fontSize: "0.9vw" } }}>
                                        <TableCell align="left">
                                            {item?.icd_code?.length > 18 ?
                                                <Tooltip placement='top' title={item?.icd_code} arrow>
                                                    <div>{item?.icd_code.slice(0, 18) + "..."}</div></Tooltip> :
                                                item?.icd_code || "-"}
                                        </TableCell>
                                        <TableCell align="left">
                                            {item?.short_desc?.length > 33 ?
                                                <Tooltip placement='top' title={item?.short_desc} arrow>
                                                    <div>{item?.short_desc.slice(0, 33) + "..."}</div></Tooltip> :
                                                item?.short_desc || "-"}
                                        </TableCell>
                                        <TableCell align="left">
                                            {item?.desc?.length > 33 ?
                                                <Tooltip placement='top' title={item?.desc} arrow>
                                                    <div>{item?.desc.slice(0, 33) + "..."}</div></Tooltip> :
                                                item?.desc || "-"}
                                        </TableCell>
                                        <TableCell align="center">
                                            <CommonDeleteButton disable={state.isDeleteClicked || isLocked} size={"2vw"}
                                                onClick={() => {
                                                    updateState({
                                                        isDeleteClicked: true,
                                                        SelectedList: item,
                                                    })
                                                    if(props?.fromIp){
                                                        props?.callHistory(true)
                                                    }
                                                }} />
                                        </TableCell>
                                    </TableRow>
                                )) : <TableRow>
                                    <TableCell colSpan={headers.length} align="center">
                                        No Records To Be Shown
                                    </TableCell>
                                </TableRow>}
                        </TableBody>
                    </Table>
                </Card>
                {!props?.fromIp ? <SarasBoldItalic
                    Title={Title}
                    isLocked={isLocked}
                    isCompleted={false}
                    minHeight={"14vh"}
                    overallHeight={"auto"}
                    field_name={props.field_name}
                    appointmentId={props.appointmentId}
                    patientId={props.patientId}
                    systemName={props.systemName}
                    isSelected={props.isSelected}
                    isNewLayout={false}
                    successMessage={(msg) => props.successMessage(msg)}
                    errorMessage={(msg) => props.errorMessage(msg)}
                /> : null }
                {state.isDeleteClicked && <DeletePopup
                    DeletTitle={`${t("deleteMsg")}  ${Title} ${state.SelectedList?.icd_code || "-"} ?`}
                    deleteAlertPopupClose={popupClose.bind(this)}
                    removeData={deleteIcdDiagnosis.bind(this)}
                />}
                {(state.PreviousDiagnosisPopup && !props?.fromIp) ?
                    <PreviousDiagnosis
                        key={props.field_name}
                        title={Title}
                        title2={""}
                        dateList={state.dateList}
                        previousData={state.IcdCodeData || []}
                        isIcdCode={true}
                        is_loading = {state.is_previous_loading}
                        onDateChange={(date) => { getPreviousDiagnosis(date) }}
                        closePopup={closePreviousPopup}
                        onCopyDiagnosis={(data) => { handleDiagnosisCopy(data) }}
                    />
                    : null}
            </Card>
        </ShowComponents >
    )
}

export default withTranslation()(SarasIcdDiagnosis)